import { render, staticRenderFns } from "./Gists.vue?vue&type=template&id=735ee812&"
import script from "./Gists.vue?vue&type=script&lang=js&"
export * from "./Gists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports